export default class DtoAccountHabilitation {
    constructor(obj) {
        this.login = obj.login
        this.habilitation = obj.habilitation
    }
}
